const sections = document.querySelectorAll( '.splitkon-information-expanded' );
if ( sections ) {
    sections.forEach( ( section ) => {
        section.addEventListener( 'click', ( e ) => {
            if ( e.target.tagName === 'DETAILS' ) {
                e.target.toggleAttribute( 'open' );
            }
        } );
    } );
}
